The success result for the `uploadCandidate` mutation.
